import type { MyClubsContinueItem } from '@bookclub/shared';
import { MiniappSurface } from '@/shared/components/ui/MiniappSurface';
import { PrimaryButton } from '@/shared/components/ui/PrimaryButton';
import { ReaderProgressBar } from '@/shared/components/reader/ReaderProgressBar';

interface ContinueCardProps {
  item: MyClubsContinueItem;
  clubAuthor?: string | null;
  onContinue: () => void;
}

export function ContinueCard({ item, clubAuthor, onContinue }: ContinueCardProps) {
  return (
    <MiniappSurface className="p-3.5 min-[430px]:p-4">
      <div className="flex items-start gap-3">
        <div className="relative h-[108px] w-[84px] shrink-0 overflow-hidden rounded-[18px] bg-[linear-gradient(180deg,#f4ead5_0%,#efe3cb_100%)] shadow-[0_12px_24px_rgba(62,48,23,0.12)] min-[430px]:h-[122px] min-[430px]:w-[94px]">
          {item.clubCoverUrl ? (
            <img
              src={item.clubCoverUrl}
              alt={item.clubTitle}
              className="absolute inset-0 h-full w-full object-cover"
            />
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-[linear-gradient(180deg,rgba(255,255,255,0.24),rgba(255,248,231,0.78))] text-[rgba(26,26,26,0.34)]">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
              </svg>
            </div>
          )}
        </div>

        <div className="min-w-0 flex-1 space-y-2.5 pt-0.5">
          <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[var(--accent)]">
            Продолжить чтение
          </p>
          <div className="min-w-0 space-y-1">
            <h3 className="line-clamp-2 text-[15px] font-black uppercase leading-[1.02] tracking-[0.01em] text-[var(--foreground)] min-[430px]:text-[17px]">
              {item.clubTitle}
            </h3>
            {clubAuthor && (
              <p className="text-[12px] leading-[1.25] text-[rgba(26,26,26,0.62)] min-[430px]:text-[13px]">
                {clubAuthor}
              </p>
            )}
            <p className="line-clamp-2 text-[11px] leading-[1.35] text-[rgba(26,26,26,0.58)] min-[430px]:text-[12px]">
              Глава {item.chapterIndex} — {item.chapterTitle}
            </p>
          </div>

          <ReaderProgressBar
            value={item.progressPercent}
            label="Прогресс"
            tone="accent"
            compact
          />
        </div>
      </div>

      <PrimaryButton
        onClick={onContinue}
        className="mt-3 w-full"
        aria-label={`Продолжить чтение ${item.clubTitle}`}
      >
        Продолжить
      </PrimaryButton>
    </MiniappSurface>
  );
}
